/**
 * Kontoauszuege oder Kreditkarten: zwei getrennte Seiten desselben Werkzeugs.
 *
 * Welche gerade gilt, steht in der Adresse. Die Kontoauszuege behalten ihre
 * bisherigen Adressen (/eingang, /mandanten, /exporte), damit Lesezeichen
 * weiter stimmen. Die Kreditkarten liegen darunter mit Vorsilbe
 * (/kreditkarten/eingang ...). Ein geoeffneter Auszug (/auszuege/:id) kennt
 * seine Art selbst.
 */
import { useLocation } from 'react-router'

export type Art = 'kontoauszug' | 'kreditkarte'

const VORSILBE = '/kreditkarten'

export function artAusPfad(pfad: string): Art {
  return pfad === VORSILBE || pfad.startsWith(`${VORSILBE}/`) ? 'kreditkarte' : 'kontoauszug'
}

/** Der Pfad einer Seite in der Welt dieser Art: pfad('kreditkarte', '/eingang') ist /kreditkarten/eingang. */
export function pfad(art: Art, rest: string): string {
  return art === 'kreditkarte' ? `${VORSILBE}${rest}` : rest
}

/** Derselbe Ort in der anderen Welt: /kreditkarten/mandanten/7 wird /mandanten/7 und umgekehrt. */
export function pfadIn(art: Art, aktuell: string): string {
  const rest = artAusPfad(aktuell) === 'kreditkarte' ? aktuell.slice(VORSILBE.length) || '/eingang' : aktuell
  return pfad(art, rest)
}

export function useArt(): Art {
  return artAusPfad(useLocation().pathname)
}

/** Fuer die Anfragen an den Server. */
export const artParameter = (art: Art) => `art=${art}`
